export default "__VITE_ASSET__D7bRv_jL__"